// src/hooks/useAuthUser.js
import { useState, useEffect } from "react";
import { onAuthStateChanged, signOut as firebaseSignOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:5000";

export default function useAuthUser() {
  const [firebaseUser, setFirebaseUser] = useState(null); // raw Firebase user
  const [apiUser, setApiUser] = useState(null); // optional API data
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setFirebaseUser(user || null);
      if (user) {
        try {
          const token = await user.getIdToken();
          const res = await axios.get(`${API_BASE_URL}/api/me/`, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          });
          setApiUser(res.data);
        } catch (err) {
          console.error("Error fetching current user:", err.response?.data || err.message);
          setApiUser(null);
        }
      } else {
        setApiUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // Sign Out
  const signOut = async () => {
    try {
      await firebaseSignOut(auth);
      sessionStorage.clear();
      localStorage.clear();
      navigate("/login");
    } catch (err) {
      console.error("Sign out error:", err);
    }
  };

  return { firebaseUser, apiUser, signOut };
}
